import { render } from "./SupportMedicalCare.vue?vue&type=template&id=65bd9999&scoped=true"
import script from "./SupportMedicalCare.vue?vue&type=script&lang=js"
export * from "./SupportMedicalCare.vue?vue&type=script&lang=js"

import "./SupportMedicalCare.vue?vue&type=style&index=0&id=65bd9999&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-65bd9999"]])

export default __exports__